const dismissedRematches = new Set<string>();

function rematchDismissedKey(matchId: string) {
  return `rematch-dismissed:${matchId}`;
}

export function isRematchDismissed(matchId: string): boolean {
  if (dismissedRematches.has(matchId)) return true;
  try {
    return sessionStorage.getItem(rematchDismissedKey(matchId)) === '1';
  } catch {
    return false;
  }
}

export function dismissRematch(matchId: string): void {
  dismissedRematches.add(matchId);
  try {
    sessionStorage.setItem(rematchDismissedKey(matchId), '1');
  } catch {
    /* ignore */
  }
}

export function rematchSourceId(payload: { matchId?: string; sourceMatchId?: string }): string | null {
  return payload.sourceMatchId ?? payload.matchId ?? null;
}

export function buildRematchGameCfg(payload: {
  matchId: string;
  opponent?: { nickname?: string; id?: string };
  boardSize?: number;
  ranked?: boolean;
  mode?: string;
}) {
  return {
    size: (payload.boardSize ?? 9) as 7 | 9,
    ranked: payload.ranked ?? false,
    local: false,
    mode: (payload.mode ?? 'online') as 'online' | 'friend',
    matchId: payload.matchId,
    opponent: payload.opponent?.nickname ?? 'Соперник',
    opponentId: payload.opponent?.id,
    ended: false,
  };
}

export function rematchOfferFromPayload(payload: {
  matchId: string;
  sourceMatchId?: string;
  fromUser?: { id?: string; nickname?: string };
  boardSize?: number;
  ranked?: boolean;
  mode?: 'online' | 'friend';
}, rematchFrom: string) {
  const sourceId = payload.sourceMatchId ?? payload.matchId;
  if (sourceId !== rematchFrom) return null;
  return { ...payload, matchId: rematchFrom };
}
